<template>
  <DialogContainer v-model="dialogObj">
    <template v-slot:dialogSlot>
      <div class="business-body custom-form">
        <el-row>
          <el-col :span="24" class="label-val">
            <span class="label">取消订单：</span>
            <span class="value color1269FF">{{ detail.orderNo }}</span>
          </el-col>
          <el-col :span="24" class="label-val">
            <span class="label"
              >{{ detail.cancelType === 21 ? "司机" : "货主" }}：</span
            >
            <span class="value"
              >{{ detail.cancelUserName || "-" }}
              <span v-if="detail.cancelUserPhone"
                >({{ detail.cancelUserPhone }})</span
              ></span
            >
          </el-col>
          <!--          <el-col :span="24" class="label-val">-->
          <!--            <span class="label">发起人信息：</span>-->
          <!--            <span class="value">王海洋（15928585007）</span>-->
          <!--          </el-col>-->
          <el-col :span="24" class="label-val">
            <span class="label">取消原因：</span>
            <span class="value">{{ detail.cancelMsg || "-" }}</span>
          </el-col>
          <el-col :span="24" class="label-val">
            <span class="label">发起时间：</span>
            <span class="value">{{ detail.cancelTime || "-" }}</span>
          </el-col>
        </el-row>
        <div class="title-box">
          <el-image :src="cheImage" class="title-label"></el-image>审批结果
        </div>
        <div class="examine2-box" v-if="isDetail">
          <div class="list">
            <span class="label">审批结果：</span>
            <span class="value">{{
              getLocalLabel("auditStatus", detail.auditStatus)
            }}</span>
          </div>
          <div class="list">
            <span class="label">操作人：</span>
            <span class="value">{{ detail.auditUserName || "-" }}</span>
          </div>
          <div class="list">
            <span class="label">操作时间：</span>
            <span class="value">{{ detail.auditTime || "-" }}</span>
          </div>
          <div class="list">
            <span class="label">备注：</span>
            <span class="value">{{ detail.auditMsg || "-" }}</span>
          </div>
        </div>
        <el-row :gutter="20" v-else>
          <el-form ref="form" :model="form" :rules="rules" label-position="top">
            <el-col :span="24">
              <el-form-item prop="realPrice">
                <el-radio-group v-model="form.pass">
                  <el-radio :label="true">同意</el-radio>
                  <el-radio :label="false">不同意</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="24" v-if="form.pass">
              <el-form-item label="客户支付金额:" >
                <span style="font-size: 18px;color: #0a65f0;">{{form.actualPayableFee}}元</span>
              </el-form-item>
            </el-col>
            <el-col :span="24" v-if="form.pass">
              <el-form-item prop="refundAmount" label="退款金额:">
                <el-input
                  clearable
                  :placeholder="`请输入小于等于${form.actualPayableFee}元`"
                  v-model="form.refundAmount"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item prop="auditMsg" label="备注:">
                <el-input
                  type="textarea"
                  clearable
                  rows="5"
                  placeholder="请输入备注"
                  v-model="form.auditMsg"
                  show-word-limit
                  maxlength="50"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-form>
        </el-row>
      </div>
    </template>
  </DialogContainer>
</template>

<script>
import DialogContainer from "@/components/Dialog.vue";
import { auditCancelOrder } from "./api";
import { getLocalLabel } from "@/utils/localDict";
import { priceReg } from "@/utils/validate";
export default {
  name: "AddOrEdit",
  components: {
    DialogContainer,
  },
  data() {
    var  validatePrice = (rule, value, callback) => {
      if (!value) {
        callback();
      }
      if (!priceReg.test(value)) {
        return callback(new Error("请正确输入，保留两位小数"));
      } else {
        if (Number(this.form.refundAmount) > Number(this.form.actualPayableFee)) {
          return callback(new Error(`请输入小于等于${this.form.actualPayableFee}元`));
        } else {
          callback();
        }
      }
    }
    return {
      cheImage: require("@/assets/imgs/title.png"),
      dialogObj: {
        loading: false,
        btnLoading: false,
        width: "30%",
        show: false,
        title: "",
        closeOnClickModal: false,
        confirmFn: this.submitForm,
        beforeClose: (v) => {
          this.form = this.$options.data().form;
          if (this.$refs.form) this.$refs.form.resetFields();
          this.dialogObj.show = false;
          this.dialogObj.btnLoading = false;
        },
      },
      isDetail: false,
      detail: {},
      form: {
        auditMsg: "",
        actualPayableFee: "",
        refundAmount: "",
        cancelId: "",
        pass: true,
      },
      rules: {
        pass: [{ required: true, message: "不能为空" }],
        refundAmount: [
          { required: true, message: "退款金额不能为空", trigger: "change" },
          { validator: validatePrice, trigger: "change" },
        ],
        // auditMsg: [{ required: true, message: "备注不能为空" }],
      },
    };
  },
  mounted() {},
  methods: {
    getLocalLabel,
    init(title, isDetail, row) {
      if (isDetail) {
        this.dialogObj.confirmFn = null;
      } else {
        this.dialogObj.confirmFn = this.submitForm;
      }
      this.dialogObj.title = title;
      this.isDetail = isDetail;
      if (!!row) {
        this.detail = Object.assign({}, row);
        this.form.cancelId = row.cancelId;
        this.form.actualPayableFee = row.actualPayableFee;
      }
      this.dialogObj.show = true;
    },

    // 提交数据
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.dialogObj.btnLoading = true;
          const par = {
            auditMsg: this.form.auditMsg,
            cancelId: this.form.cancelId,
            pass: this.form.pass,
            refundAmount: this.form.refundAmount,
          };
          auditCancelOrder(par)
            .then((res) => {
              this.dialogObj.btnLoading = false;
              if (res.code === 200) {
                this.$message.success("审批成功");
                this.$parent.handleAddOrEditSuccess("edit");
                this.dialogObj.beforeClose();
              }
            })
            .catch((e) => {
              this.dialogObj.btnLoading = false;
            });
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.business-body {
  box-sizing: border-box;
  .label-val {
    margin-bottom: 0.16rem;
  }
  .title-box {
    padding: 0.1rem 0 0.1rem;
    color: #000000;
    .title-label {
      width: 0.08rem;
      height: 0.08rem;
      margin-right: 0.06rem;
    }
  }
  .examine2-box {
    background-color: #f7fbff;
    border-radius: 0.08rem;
    padding: 0.1rem;
    box-sizing: border-box;
    margin-top: 0.1rem;
    .list {
      line-height: 0.2rem;
    }
  }
}
</style>
